import { render, staticRenderFns } from "./InputNumberCpt.vue?vue&type=template&id=4632c084&scoped=true&"
import script from "./InputNumberCpt.vue?vue&type=script&lang=ts&"
export * from "./InputNumberCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputNumberCpt.vue?vue&type=style&index=0&id=4632c084&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4632c084",
  null
  
)

export default component.exports